// import React, { useEffect, useMemo, useState } from "react";
// import {
//   Container,
//   Form,
//   Label,
//   Input,
//   ModalHeader,
//   ModalBody,
//   Button,
//   Table,
//   Row,
//   Col,
//   Card,
//   CardBody,
//   Modal,
// } from "reactstrap";
// import { colourStyles } from "utils/common-options";
// import Select from "react-select";
// import moment from "moment";
// import Loader from "pages/Separate/Loader";
// import {
//   fetchData,
//   fetchNodeData,
//   FetchNodePostData,
//   FetchNodePutData,
// } from "utils/common-fetchData";
// import secureLocalStorage from "react-secure-storage";

// export const calculateDueDate = (startDate, duration) => {
//   if (!startDate || !duration) return "";

//   const date = new Date(startDate);
//   const [value, unit] = duration.split(" ");
//   const amount = Number(value);

//   if (unit === "Month") {
//     date.setMonth(date.getMonth() + amount);
//   } else if (unit === "Year") {
//     date.setFullYear(date.getFullYear() + amount);
//   }

//   // subtract 1 day to make it end-date (expiry)
//   date.setDate(date.getDate() - 1);

//   return date.toISOString().split("T")[0];
// };

// const HostingModal = ({
//   modal,
//   setModal,
//   handleSubmit,
//   locationOptions,
//   customerOptions,
//   projectOptions,
//   packageOptions,
//   setCustomerOption,
//   setProjectOptions,
//   allServicesOptions,
//   hostingDurations,
//   location,
//   setLocation,
//   customer,
//   setCustomer,
//   project,
//   setProject,
//   Package,
//   setPackage,

//   services,
//   setServices,
//   isEdit,
//   setEdit,

//   isRenew,
//   setRenew,
// }) => {
//   console.log("services", services);
//   const handleAddService = () => {
//     const newId = -1 * (services.length + 1);
//     setServices((prev) => [
//       ...prev,
//       {
//         id: newId,
//         service: "",
//         description: "",
//         price: "",
//         basePrice: "",
//         startDate: "",
//         dueDate: "",
//         currency: "",
//         service_box: "yes",
//         isPackageService: false,
//         renewButton: true,
//       },
//     ]);
//   };

//   const [currencyOptions, setCurrencyOptions] = useState([]);
//   const [isLoading, setLoading] = useState(false);

//   // NEW STATES FOR RENEW START DATE MODAL
//   const [renewStartDateModal, setRenewStartDateModal] = useState(false);
//   const [selectedRenewDate, setSelectedRenewDate] = useState("");
//   const [currentServiceId, setCurrentServiceId] = useState(null);

//   useEffect(() => {
//     (async () => {
//       const response = await fetchData(
//         setLoading,
//         "currency",
//         secureLocalStorage?.getItem("auth_token"),
//       );

//       console.log("Currenciesss", response?.data?.currency);

//       if (response?.success) {
//         const options = response?.data?.currency?.map((c) => ({
//           label: c.currency,
//           value: c.currency,
//           symbol: c.symbol,
//         }));

//         console.log("Currency Options:", options);
//         setCurrencyOptions(options);
//       }
//     })();
//   }, []);

//   const handleRemoveService = (id) => {
//     setServices((prev) => prev.filter((srv) => srv.id !== id));
//   };

//   function handleUpdateServices(id, field, value) {
//     setServices((prev) =>
//       prev.map((srv) => {
//         if (srv.id == id) {
//           srv[field] = value;
//           srv.dueDate = calculateDueDate(srv?.startDate, srv?.renewalDuration);
//         }
//         return srv;
//       }),
//     );
//   }

//   // Reset fields
//   useEffect(() => {
//     if (!modal) {
//       setLocation(null);
//       setCustomer(null);
//       setProject(null);
//       setPackage(null);
//       if (isEdit) setEdit(false);
//       if (isRenew) setRenew(false);
//     }
//   }, [modal]);

//   const totalPrice = useMemo(
//     () => services?.reduce((acc, curr) => acc + (Number(curr.price) || 0), 0),
//     [services],
//   );

//   const totalBase = useMemo(
//     () =>
//       services?.reduce((acc, curr) => acc + (Number(curr.basePrice) || 0), 0),
//     [services],
//   );

//   return (
//     <>
//       {isLoading && <Loader />}
//       <Modal
//         isOpen={modal}
//         toggle={() => setModal((prev) => !prev)}
//         className="modal-fullscreen"
//         centered
//       >
//         <ModalHeader className="px-5" toggle={() => setModal((prev) => !prev)}>
//           <div className="mb-1">
//             {isRenew ? "Renew" : isEdit ? "Edit" : "Add"} Hosting
//           </div>
//           {isRenew && (
//             <div className="text-muted">
//               <div className="mt-1 fs-6">
//                 <span className="me-3">
//                   Customer: <strong>{customer?.label || "-"}</strong>
//                 </span>
//                 <span>
//                   Location: <strong>{location?.label || "-"}</strong>
//                 </span>
//               </div>
//             </div>
//           )}
//         </ModalHeader>
//         <ModalBody>
//           <div className="row px-4">
//             <div className="col-md-12">
//               <Form onSubmit={handleSubmit}>
//                 <Row>
//                   {!isRenew && (
//                     <>
//                       <Col md={4} className="mb-3">
//                         <label htmlFor="location">
//                           Location <span className="text-danger">*</span>
//                         </label>
//                         <Select
//                           placeholder="Select Location"
//                           className="basic-multi-select"
//                           classNamePrefix="select"
//                           options={locationOptions}
//                           value={location}
//                           onChange={(value) => {
//                             setLocation(value);
//                             setCustomer(null);
//                             setProject(null);
//                             // setCustomerOption(null)
//                             // setProjectOptions(null)
//                           }}
//                           required
//                           styles={colourStyles}
//                         />
//                       </Col>
//                       <Col md={4} className="mb-3">
//                         <label htmlFor="customer">
//                           Customer <span className="text-danger">*</span>
//                         </label>
//                         <Select
//                           placeholder="Select Customer"
//                           className="basic-multi-select"
//                           classNamePrefix="select"
//                           options={customerOptions}
//                           value={customer}
//                           onChange={(value) => {
//                             setCustomer(value);
//                             setProject(null);
//                           }}
//                           required
//                           styles={colourStyles}
//                         />
//                       </Col>
//                       <Col md={4} className="mb-3">
//                         <Label>Project</Label>
//                         {/* <span className="text-danger">*</span> */}
//                         <Select
//                           placeholder="Select Project"
//                           className="basic-multi-select"
//                           classNamePrefix="select"
//                           options={projectOptions}
//                           value={project}
//                           onChange={(value) => setProject(value)}
//                           styles={colourStyles}
//                         />
//                       </Col>
//                     </>
//                   )}
//                   <Col md={4} className="mb-3">
//                     <Label>Package</Label>
//                     <span className="text-danger">*</span>
//                     <Select
//                       placeholder="Select Package"
//                       className="basic-multi-select"
//                       classNamePrefix="select"
//                       options={packageOptions}
//                       value={Package}
//                       onChange={(selected) => {
//                         setPackage(selected);

//                         const servicesOpts = selected?.services?.map(
//                           (item) => ({
//                             id: item.id,
//                             service: item.service_name,
//                             description: "",
//                             price: item.price,
//                             basePrice: item.price,
//                             startDate: "",
//                             dueDate: "",
//                             currency: item.currency || "",
//                             renewalDuration: "",
//                             service_box: item.service_box,
//                             isPackageService: true,
//                           }),
//                         );
//                         setServices(servicesOpts);
//                       }}
//                       required
//                       isDisabled={isRenew}
//                       styles={colourStyles}
//                     />
//                   </Col>
//                 </Row>

//                 {Package?.value && (
//                   <>
//                     <div className="d-flex justify-content-end">
//                       {/* {!isRenew && ( */}
//                       <Button
//                         color="success"
//                         className="mb-2"
//                         onClick={handleAddService}
//                       >
//                         <i className="fa fa-plus me-1"></i> Service
//                       </Button>
//                       {/* )} */}
//                     </div>

//                     <Table bordered>
//                       <thead>
//                         <tr>
//                           <th>Service</th>
//                           <th className="col-md-2">Description</th>
//                           <th>Start Date</th>
//                           <th>Duration</th>
//                           <th>Expiry Date</th>
//                           <th>Currency</th>
//                           <th className="col-md-1">Price</th>
//                           <th className="col-md-1">Base Price</th>
//                           <th></th>
//                         </tr>
//                       </thead>
//                       <tbody>
//                         {services.map((s) => {
//                           const targetDate = moment(s.dueDate);
//                           const today = moment();

//                           const isCurrentMonth =
//                             targetDate.isSame(today, "month") &&
//                             targetDate.isSame(today, "year");

//                           const isPast = targetDate.isBefore(today, "day");

//                           return (
//                             <tr
//                               key={s.id}
//                               className={`
//                                 ${isCurrentMonth ? "bg-lightred" : ""}
//                                 ${!isCurrentMonth && isPast ? "bg-darkred" : ""}
//                               `}
//                             >
//                               <td>
//                                 {s.isPackageService ? (
//                                   <Input value={s.service} disabled readOnly />
//                                 ) : (
//                                   <Select
//                                     placeholder="Service"
//                                     className="basic-multi-select"
//                                     classNamePrefix="select"
//                                     options={allServicesOptions}
//                                     value={
//                                       allServicesOptions.find(
//                                         (opt) => opt.value == s.service,
//                                       ) || null
//                                     }
//                                     onChange={(selected) => {
//                                       console.log(selected);
//                                       // Update service id
//                                       handleUpdateServices(
//                                         s.id,
//                                         "service",
//                                         selected.value,
//                                       );

//                                       // Update price and basePrice
//                                       handleUpdateServices(
//                                         s.id,
//                                         "price",
//                                         selected.price || 0,
//                                       );
//                                       handleUpdateServices(
//                                         s.id,
//                                         "basePrice",
//                                         selected.price || 0,
//                                       );

//                                       handleUpdateServices(
//                                         s.id,
//                                         "service_box",
//                                         selected.service_box || "no",
//                                       );

//                                       // Optionally set currency for this service
//                                       // handleUpdateServices(s.id, "currency", selected.currency || "")
//                                     }}
//                                     styles={{
//                                       ...colourStyles,
//                                       menuPortal: (base) => ({
//                                         ...base,
//                                         zIndex: 9999,
//                                       }),
//                                     }}
//                                     menuPortalTarget={document.body}
//                                   />
//                                 )}
//                               </td>
//                               <td>
//                                 {s.service_box === "yes" ? (
//                                   <Input
//                                     type="textarea"
//                                     rows={3}
//                                     value={s.description}
//                                     onChange={(e) => {
//                                       handleUpdateServices(
//                                         s.id,
//                                         "description",
//                                         e.target.value,
//                                       );
//                                     }}
//                                     // disabled={isRenew}
//                                   />
//                                 ) : null}
//                               </td>

//                               <td>
//                                 <input
//                                   type="date"
//                                   className="form-control"
//                                   value={s.startDate}
//                                   onChange={(e) => {
//                                     handleUpdateServices(
//                                       s.id,
//                                       "startDate",
//                                       e.target.value,
//                                     );
//                                   }}
//                                 />
//                               </td>
//                               <td>
//                                 <Select
//                                   placeholder="Duration"
//                                   className="basic-multi-select"
//                                   classNamePrefix="select"
//                                   options={hostingDurations}
//                                   value={
//                                     hostingDurations.find(
//                                       (opt) => opt.label == s.renewalDuration,
//                                     ) || null
//                                   }
//                                   onChange={(e) => {
//                                     handleUpdateServices(
//                                       s.id,
//                                       "renewalDuration",
//                                       e.label,
//                                     );
//                                   }}
//                                   required
//                                   styles={colourStyles}
//                                 />
//                               </td>
//                               <td>
//                                 <input
//                                   type="date"
//                                   className="form-control"
//                                   value={s.dueDate}
//                                   disabled
//                                 />
//                               </td>
//                               <td>
//                                 <Select
//                                   placeholder="Currency"
//                                   options={currencyOptions}
//                                   value={
//                                     currencyOptions.find(
//                                       (opt) => opt.value === s.currency,
//                                     ) || null
//                                   }
//                                   onChange={(selected) =>
//                                     handleUpdateServices(
//                                       s.id,
//                                       "currency",
//                                       selected.value,
//                                     )
//                                   }
//                                   styles={colourStyles}
//                                   getOptionLabel={(option) =>
//                                     `${option.label} ${option.symbol || ""}`
//                                   }
//                                 />
//                               </td>
//                               <td>
//                                 <Input
//                                   type="text"
//                                   value={`${
//                                     currencyOptions.find(
//                                       (opt) => opt.value === s.currency,
//                                     )?.symbol || ""
//                                   }${s.price || ""} `}
//                                   onChange={(e) => {
//                                     // Extract only the numeric part before updating
//                                     const numericValue = e.target.value.replace(
//                                       /[^0-9.]/g,
//                                       "",
//                                     );
//                                     handleUpdateServices(
//                                       s.id,
//                                       "price",
//                                       numericValue,
//                                     );
//                                   }}
//                                 />
//                               </td>
//                               <td>
//                                 <Input
//                                   type="text"
//                                   value={s.basePrice}
//                                   disabled
//                                   readOnly
//                                 />
//                               </td>

//                               <td>
//                                 <div className="d-flex flex-wrap gap-1 justify-content-center">
//                                   {isRenew && !s.renewButton && (
//                                     <button
//                                       type="button"
//                                       onClick={() => {
//                                         setCurrentServiceId(s.id);
//                                         setSelectedRenewDate(
//                                           new Date()
//                                             .toISOString()
//                                             .split("T")[0],
//                                         );
//                                         setRenewStartDateModal(true);
//                                       }}
//                                       className="btn btn-sm btn-purple"
//                                     >
//                                       <i className="fa fa-refresh me-1 label-icon"></i>
//                                       <span className="d-none d-sm-inline">
//                                         Renew
//                                       </span>
//                                     </button>
//                                   )}

//                                   <Button
//                                     color="danger"
//                                     size="sm"
//                                     onClick={() => handleRemoveService(s.id)}
//                                   >
//                                     <i className="fa fa-times"></i>
//                                   </Button>
//                                 </div>
//                               </td>
//                             </tr>
//                           );
//                         })}
//                         <tr>
//                           <td colSpan={5} className="text-end fw-bold">
//                             Total
//                           </td>
//                           <td>{totalPrice?.toFixed(2)}</td>
//                           <td>{totalBase?.toFixed(2)}</td>
//                           <td></td>
//                         </tr>
//                       </tbody>
//                     </Table>
//                   </>
//                 )}

//                 <div className="text-end mt-3">
//                   {/* {!isRenew && ( */}
//                   <button
//                     type="submit"
//                     className="btn ms-md-2 btn-save btn-label"
//                   >
//                     <i className="fas fa-save me-1 label-icon"></i> Submit
//                   </button>
//                   {/* )} */}
//                 </div>
//               </Form>
//             </div>
//           </div>
//         </ModalBody>
//       </Modal>

//       {/* NEW MODAL FOR RENEW START DATE */}
//       <Modal
//         isOpen={renewStartDateModal}
//         toggle={() => setRenewStartDateModal(false)}
//         centered
//       >
//         <ModalHeader toggle={() => setRenewStartDateModal(false)}>
//           Select Start Date
//         </ModalHeader>
//         <ModalBody>
//           <div className="mb-3">
//             <Label>Start Date</Label>
//             <Input
//               type="date"
//               value={selectedRenewDate}
//               onChange={(e) => setSelectedRenewDate(e.target.value)}
//             />
//           </div>
//           <div className="text-end">
//             <Button
//               color="primary"
//               onClick={() => {
//                 console.log(currentServiceId);
//                 // Update service start date
//                 handleUpdateServices(
//                   currentServiceId,
//                   "startDate",
//                   selectedRenewDate,
//                 );

//                 // Close modal
//                 setRenewStartDateModal(false);

//                 // Call the original renew submit
//                 handleSubmit(null, currentServiceId);
//               }}
//             >
//               OK
//             </Button>
//           </div>
//         </ModalBody>
//       </Modal>
//     </>
//   );
// };

// export default HostingModal;

import React, { useEffect, useMemo, useState } from "react";
import {
  Container,
  Form,
  Label,
  Input,
  ModalHeader,
  ModalBody,
  Button,
  Table,
  Row,
  Col,
  Card,
  CardBody,
  Modal,
} from "reactstrap";
import { colourStyles } from "utils/common-options";
import Select from "react-select";
import moment from "moment";
import Loader from "pages/Separate/Loader";
import {
  fetchData,
  fetchNodeData,
  FetchNodePostData,
  FetchNodePutData,
} from "utils/common-fetchData";
import secureLocalStorage from "react-secure-storage";
import Swal from "sweetalert2";

export const calculateDueDate = (startDate, duration) => {
  if (!startDate || !duration) return "";

  const date = new Date(startDate);
  const [value, unit] = duration.split(" ");
  const amount = Number(value);

  if (unit === "Month") {
    date.setMonth(date.getMonth() + amount);
  } else if (unit === "Year") {
    date.setFullYear(date.getFullYear() + amount);
  }

  // subtract 1 day to make it end-date (expiry)
  date.setDate(date.getDate() - 1);

  return date.toISOString().split("T")[0];
};

const HostingModal = ({
  modal,
  setModal,
  handleSubmit,
  locationOptions,
  customerOptions,
  projectOptions,
  packageOptions,
  setCustomerOption,
  setProjectOptions,
  allServicesOptions,
  hostingDurations,
  location,
  setLocation,
  customer,
  setCustomer,
  project,
  setProject,
  Package,
  setPackage,

  services,
  setServices,
  isEdit,
  setEdit,

  isRenew,
  setRenew,
}) => {
  console.log("services", services);
  const handleAddService = () => {
    const newId = -1 * (services.length + 1);
    setServices((prev) => [
      ...prev,
      {
        id: newId,
        service: "",
        description: "",
        price: "",
        basePrice: "",
        startDate: "",
        dueDate: "",
        currency: "",
        service_box: "yes",
        isPackageService: false,
        renewButton: true,
      },
    ]);
  };

  const [currencyOptions, setCurrencyOptions] = useState([]);
  const [isLoading, setLoading] = useState(false);

  // NEW STATES FOR RENEW START DATE MODAL
  const [renewStartDateModal, setRenewStartDateModal] = useState(false);
  const [selectedRenewDate, setSelectedRenewDate] = useState("");
  const [currentServiceId, setCurrentServiceId] = useState(null);

  // ADD THIS ↓
  const [selectedRenewIds, setSelectedRenewIds] = useState([]);

  const handleRenewCheckbox = (id) => {
    setSelectedRenewIds((prev) =>
      prev.includes(id) ? prev.filter((sid) => sid !== id) : [...prev, id],
    );
  };

  useEffect(() => {
    (async () => {
      const response = await fetchData(
        setLoading,
        "currency",
        secureLocalStorage?.getItem("auth_token"),
      );

      console.log("Currenciesss", response?.data?.currency);

      if (response?.success) {
        const options = response?.data?.currency?.map((c) => ({
          label: c.currency,
          value: c.currency,
          symbol: c.symbol,
        }));

        console.log("Currency Options:", options);
        setCurrencyOptions(options);
      }
    })();
  }, []);

  const handleRemoveService = (id) => {
    setServices((prev) => prev.filter((srv) => srv.id !== id));
  };

  function handleUpdateServices(id, field, value) {
    setServices((prev) =>
      prev.map((srv) => {
        if (srv.id == id) {
          srv[field] = value;
          srv.dueDate = calculateDueDate(srv?.startDate, srv?.renewalDuration);
        }
        return srv;
      }),
    );
  }

  // Reset fields
  useEffect(() => {
    if (!modal) {
      setLocation(null);
      setCustomer(null);
      setProject(null);
      setPackage(null);
      if (isEdit) setEdit(false);
      if (isRenew) setRenew(false);
      setSelectedRenewIds([]);
      setCurrentServiceId(null);
    }
  }, [modal]);

  const totalPrice = useMemo(
    () => services?.reduce((acc, curr) => acc + (Number(curr.price) || 0), 0),
    [services],
  );

  const totalBase = useMemo(
    () =>
      services?.reduce((acc, curr) => acc + (Number(curr.basePrice) || 0), 0),
    [services],
  );

  return (
    <>
      {isLoading && <Loader />}
      <Modal
        isOpen={modal}
        toggle={() => setModal((prev) => !prev)}
        className="modal-fullscreen"
        centered
      >
        <ModalHeader className="px-5" toggle={() => setModal((prev) => !prev)}>
          <div className="mb-1">
            {isRenew ? "Renew" : isEdit ? "Edit" : "Add"} Hosting
          </div>
          {isRenew && (
            <div className="text-muted">
              <div className="mt-1 fs-6">
                <span className="me-3">
                  Customer: <strong>{customer?.label || "-"}</strong>
                </span>
                <span>
                  Location: <strong>{location?.label || "-"}</strong>
                </span>
              </div>
            </div>
          )}
        </ModalHeader>
        <ModalBody>
          <div className="row px-4">
            <div className="col-md-12">
              <Form onSubmit={handleSubmit}>
                <Row>
                  {!isRenew && (
                    <>
                      <Col md={4} className="mb-3">
                        <label htmlFor="location">
                          Location <span className="text-danger">*</span>
                        </label>
                        <Select
                          placeholder="Select Location"
                          className="basic-multi-select"
                          classNamePrefix="select"
                          options={locationOptions}
                          value={location}
                          onChange={(value) => {
                            setLocation(value);
                            setCustomer(null);
                            setProject(null);
                            // setCustomerOption(null)
                            // setProjectOptions(null)
                          }}
                          required
                          styles={colourStyles}
                        />
                      </Col>
                      <Col md={4} className="mb-3">
                        <label htmlFor="customer">
                          Customer <span className="text-danger">*</span>
                        </label>
                        <Select
                          placeholder="Select Customer"
                          className="basic-multi-select"
                          classNamePrefix="select"
                          options={customerOptions}
                          value={customer}
                          onChange={(value) => {
                            setCustomer(value);
                            setProject(null);
                          }}
                          required
                          styles={colourStyles}
                        />
                      </Col>
                      <Col md={4} className="mb-3">
                        <Label>Project</Label>
                        {/* <span className="text-danger">*</span> */}
                        <Select
                          placeholder="Select Project"
                          className="basic-multi-select"
                          classNamePrefix="select"
                          options={projectOptions}
                          value={project}
                          onChange={(value) => setProject(value)}
                          styles={colourStyles}
                        />
                      </Col>
                    </>
                  )}
                  <Col md={4} className="mb-3">
                    <Label>Package</Label>
                    <span className="text-danger">*</span>
                    <Select
                      placeholder="Select Package"
                      className="basic-multi-select"
                      classNamePrefix="select"
                      options={packageOptions}
                      value={Package}
                      onChange={(selected) => {
                        setPackage(selected);

                        const servicesOpts = selected?.services?.map(
                          (item) => ({
                            id: item.id,
                            service: item.service_name,
                            description: "",
                            price: item.price,
                            basePrice: item.price,
                            startDate: "",
                            dueDate: "",
                            currency: item.currency || "",
                            renewalDuration: "",
                            service_box: item.service_box,
                            isPackageService: true,
                          }),
                        );
                        setServices(servicesOpts);
                      }}
                      required
                      isDisabled={isRenew}
                      styles={colourStyles}
                    />
                  </Col>
                </Row>

                {Package?.value && (
                  <>
                    <div className="d-flex justify-content-end gap-2">
                      {isRenew && selectedRenewIds.length > 0 && (
                        <Button
                          color="purple" // or "primary" if purple isn't configured
                          className="mb-2 btn-purple"
                          type="button"
                          onClick={() => {
                            setCurrentServiceId(null); // multi-mode: no single id
                            setSelectedRenewDate(
                              new Date().toISOString().split("T")[0],
                            );
                            setRenewStartDateModal(true);
                          }}
                        >
                          <i className="fa fa-refresh me-1"></i>
                          Renew Selected ({selectedRenewIds.length})
                        </Button>
                      )}
                      <Button
                        color="success"
                        className="mb-2"
                        onClick={handleAddService}
                      >
                        <i className="fa fa-plus me-1"></i> Service
                      </Button>
                    </div>

                    <Table bordered>
                      <thead>
                        <tr>
                          {isRenew && <th>Select</th>} {/* ADD THIS */}
                          <th>Service</th>
                          <th className="col-md-2">Description</th>
                          <th>Start Date</th>
                          <th>Duration</th>
                          <th>Expiry Date</th>
                          <th>Currency</th>
                          <th className="col-md-1">Price</th>
                          <th className="col-md-1">Base Price</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        {services.map((s) => {
                          const targetDate = moment(s.dueDate);
                          const today = moment();

                          const isCurrentMonth =
                            targetDate.isSame(today, "month") &&
                            targetDate.isSame(today, "year");

                          const isPast = targetDate.isBefore(today, "day");

                          return (
                            <tr
                              key={s.id}
                              className={`
                                ${isCurrentMonth ? "bg-lightred" : ""}
                                ${!isCurrentMonth && isPast ? "bg-darkred" : ""}
                              `}
                            >
                              {/* ADD THIS ↓ */}
                              {isRenew && !s.renewButton && (
                                <td className="text-center align-middle">
                                  <input
                                    type="checkbox"
                                    checked={selectedRenewIds.includes(s.id)}
                                    onClick={() => handleRenewCheckbox(s.id)}
                                  />
                                </td>
                              )}
                              {isRenew && s.renewButton && <td></td>}
                              <td>
                                {s.isPackageService ? (
                                  <Input value={s.service} disabled readOnly />
                                ) : (
                                  <Select
                                    placeholder="Service"
                                    className="basic-multi-select"
                                    classNamePrefix="select"
                                    options={allServicesOptions}
                                    value={
                                      allServicesOptions.find(
                                        (opt) => opt.value == s.service,
                                      ) || null
                                    }
                                    onChange={(selected) => {
                                      console.log(selected);
                                      // Update service id
                                      handleUpdateServices(
                                        s.id,
                                        "service",
                                        selected.value,
                                      );

                                      // Update price and basePrice
                                      handleUpdateServices(
                                        s.id,
                                        "price",
                                        selected.price || 0,
                                      );
                                      handleUpdateServices(
                                        s.id,
                                        "basePrice",
                                        selected.price || 0,
                                      );

                                      handleUpdateServices(
                                        s.id,
                                        "service_box",
                                        selected.service_box || "no",
                                      );

                                      // Optionally set currency for this service
                                      // handleUpdateServices(s.id, "currency", selected.currency || "")
                                    }}
                                    styles={{
                                      ...colourStyles,
                                      menuPortal: (base) => ({
                                        ...base,
                                        zIndex: 9999,
                                      }),
                                    }}
                                    menuPortalTarget={document.body}
                                  />
                                )}
                              </td>
                              <td>
                                {s.service_box === "yes" ? (
                                  <Input
                                    type="textarea"
                                    rows={3}
                                    value={s.description}
                                    onChange={(e) => {
                                      handleUpdateServices(
                                        s.id,
                                        "description",
                                        e.target.value,
                                      );
                                    }}
                                    // disabled={isRenew}
                                  />
                                ) : null}
                              </td>

                              <td>
                                <input
                                  type="date"
                                  className="form-control"
                                  value={s.startDate}
                                  onChange={(e) => {
                                    handleUpdateServices(
                                      s.id,
                                      "startDate",
                                      e.target.value,
                                    );
                                  }}
                                />
                              </td>
                              <td>
                                <Select
                                  placeholder="Duration"
                                  className="basic-multi-select"
                                  classNamePrefix="select"
                                  options={hostingDurations}
                                  value={
                                    hostingDurations.find(
                                      (opt) => opt.label == s.renewalDuration,
                                    ) || null
                                  }
                                  onChange={(e) => {
                                    handleUpdateServices(
                                      s.id,
                                      "renewalDuration",
                                      e.label,
                                    );
                                  }}
                                  required
                                  styles={colourStyles}
                                />
                              </td>
                              <td>
                                <input
                                  type="date"
                                  className="form-control"
                                  value={s.dueDate}
                                  disabled
                                />
                              </td>
                              <td>
                                <Select
                                  placeholder="Currency"
                                  options={currencyOptions}
                                  value={
                                    currencyOptions.find(
                                      (opt) => opt.value === s.currency,
                                    ) || null
                                  }
                                  onChange={(selected) =>
                                    handleUpdateServices(
                                      s.id,
                                      "currency",
                                      selected.value,
                                    )
                                  }
                                  styles={colourStyles}
                                  getOptionLabel={(option) =>
                                    `${option.label} ${option.symbol || ""}`
                                  }
                                />
                              </td>
                              <td>
                                <Input
                                  type="text"
                                  value={`${
                                    currencyOptions.find(
                                      (opt) => opt.value === s.currency,
                                    )?.symbol || ""
                                  }${s.price || ""} `}
                                  onChange={(e) => {
                                    // Extract only the numeric part before updating
                                    const numericValue = e.target.value.replace(
                                      /[^0-9.]/g,
                                      "",
                                    );
                                    handleUpdateServices(
                                      s.id,
                                      "price",
                                      numericValue,
                                    );
                                  }}
                                />
                              </td>
                              <td>
                                <Input
                                  type="text"
                                  value={s.basePrice}
                                  disabled
                                  readOnly
                                />
                              </td>

                              <td>
                                <div className="d-flex flex-wrap gap-1 justify-content-center">
                                  {isRenew && !s.renewButton && (
                                    <button
                                      type="button"
                                      onClick={() => {
                                        setCurrentServiceId(s.id);
                                        setSelectedRenewDate(
                                          new Date()
                                            .toISOString()
                                            .split("T")[0],
                                        );
                                        setRenewStartDateModal(true);
                                      }}
                                      className="btn btn-sm btn-purple"
                                    >
                                      <i className="fa fa-refresh me-1 label-icon"></i>
                                      <span className="d-none d-sm-inline">
                                        Renew
                                      </span>
                                    </button>
                                  )}

                                  <Button
                                    color="danger"
                                    size="sm"
                                    onClick={() => handleRemoveService(s.id)}
                                  >
                                    <i className="fa fa-times"></i>
                                  </Button>
                                </div>
                              </td>
                            </tr>
                          );
                        })}
                        <tr>
                          <td colSpan={5} className="text-end fw-bold">
                            Total
                          </td>
                          <td>{totalPrice?.toFixed(2)}</td>
                          <td>{totalBase?.toFixed(2)}</td>
                          <td></td>
                        </tr>
                      </tbody>
                    </Table>
                  </>
                )}

                <div className="text-end mt-3">
                  {/* {!isRenew && ( */}
                  <button
                    type="submit"
                    className="btn ms-md-2 btn-save btn-label"
                  >
                    <i className="fas fa-save me-1 label-icon"></i> Submit
                  </button>
                  {/* )} */}
                </div>
              </Form>
            </div>
          </div>
        </ModalBody>
      </Modal>

      {/* NEW MODAL FOR RENEW START DATE */}
      <Modal
        isOpen={renewStartDateModal}
        toggle={() => setRenewStartDateModal(false)}
        centered
      >
        <ModalHeader toggle={() => setRenewStartDateModal(false)}>
          Select Start Date
        </ModalHeader>
        <ModalBody>
          <div className="mb-3">
            <Label>Start Date</Label>
            <Input
              type="date"
              value={selectedRenewDate}
              onChange={(e) => setSelectedRenewDate(e.target.value)}
            />
          </div>
          <div className="text-end">
            <Button
              color="primary"
              onClick={async () => {
                setRenewStartDateModal(false);

                const idsToRenew =
                  selectedRenewIds.length > 0
                    ? selectedRenewIds // multi-select path
                    : [currentServiceId]; // single renew button path (existing behaviour)

                // Update startDate for all selected services
                idsToRenew.forEach((id) => {
                  handleUpdateServices(id, "startDate", selectedRenewDate);
                });

                // Let state settle
                await new Promise((resolve) => setTimeout(resolve, 0));

                if (idsToRenew.length === 1) {
                  // ── Single renew: use original flow (shows confirmation + success swal) ──
                  handleSubmit(null, idsToRenew[0]);
                } else {
                  // ── Multi renew: silent loop, one combined success at the end ────────────
                  const results = [];
                  for (const id of idsToRenew) {
                    const ok = await handleSubmit(null, id, { silent: true });
                    results.push({ id, ok });
                  }

                  const failed = results.filter((r) => !r.ok);

                  if (failed.length === 0) {
                    Swal.fire({
                      icon: "success",
                      title: "All Renewed",
                      text: `${idsToRenew.length} services renewed successfully!`,
                    });
                  } else if (failed.length < idsToRenew.length) {
                    Swal.fire({
                      icon: "warning",
                      title: "Partial Success",
                      text: `${idsToRenew.length - failed.length} renewed, ${
                        failed.length
                      } failed. Please retry the failed ones.`,
                    });
                  } else {
                    Swal.fire({
                      icon: "error",
                      title: "Failed",
                      text: "All renewals failed. Please try again.",
                    });
                  }

                  setSelectedRenewIds([]);
                  setCurrentServiceId(null);
                }
              }}
            >
              OK
            </Button>
          </div>
        </ModalBody>
      </Modal>
    </>
  );
};

export default HostingModal;
